import React, { useEffect, useState } from "react";
import "../component/style.css";
import SideNav from "../component/sideNav";
import Header from "../component/header";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { RequestDemoApi } from "../apis";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  InputAdornment,
  Tooltip,
  Alert,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import { GroupAdd, HowToReg } from "@mui/icons-material";

const Requests = () => {
  const [Requestss, setRequestss] = useState([]);
  const [paginator, setPaginator] = useState({
    page: 0,
    perPage: 10,
  });
  const [totalCount, setTotalCount] = useState(0);
  const [displayViewModal, setDisplayViewModal] = useState(false);
  const [displayDeleteModal, setDisplayDeleteModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [loader, setLoader] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [message, setMessage] = useState("");
  const RequestsRouter = RequestDemoApi();

  // Attributes
  const [searchTerm, setSearchTerm] = useState("");

  const columns = [
    {
      field: "name",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Full Name
        </div>
      ),
      flex: 1,
      renderCell: (params) => params?.value,
      sortable: false,
    },
    {
      field: "email",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Email
        </div>
      ),
      flex: 1,
      renderCell: (params) => params?.email,
      sortable: false,
    },
    {
      field: "address",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Address
        </div>
      ),
      flex: 1,
      renderCell: (params) => params?.address,
      sortable: false,
    },
    {
      field: "phone",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Phone Number
        </div>
      ),
      flex: 1,
      renderCell: (params) => params?.phone,
      sortable: false,
    },
    {
      field: "companyName",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Company Name
        </div>
      ),
      flex: 1,
      renderCell: ({ row }) => row.company_id?.name,
      sortable: false,
    },
    {
      field: "updatedAt",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Updated At
        </div>
      ),
      flex: 1,
      renderCell: ({ row }) => {
        const dateString = row?.updatedAt;
        if (!dateString) return "";
        const dateObject = new Date(dateString);
        const formattedDate = dateObject.toISOString().split("T")[0];

        return formattedDate;
      },
      sortable: false,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      getActions: ({ row }) => [
        <GridActionsCellItem
          icon={
            <Tooltip
              title={
                row?.isApproved ? "Approved" : loader ? "Pending" : "Request"
              }
              placement="top"
            >
              {row?.isApproved ? (
                <HowToReg style={{ color: "Green", width: 24, height: 24 }} />
              ) : loader && selectedRecord?._id === row?._id ? (
                <div className="sm_loader">
                  <div className="ring"></div>
                  <img src="./images/Logos/flash.svg" alt="logo"></img>
                </div>
              ) : (
                <GroupAdd style={{ color: "red", width: 24, height: 24 }} />
              )}
            </Tooltip>
          }
          label={row?.isApproved ? "Approved" : "Request"}
          onClick={() => {
            if (row?.isApproved) {
              return null;
            } else {
              setSelectedRecord(row);
              updateRequests(row);
            }
          }}
        />,
        <GridActionsCellItem
          icon={
            <Tooltip title="Delete" placement="top">
              <DeleteIcon style={{ color: "red", width: 24, height: 24 }} />
            </Tooltip>
          }
          label="Delete"
          onClick={() => {
            toggleDeleteModal();
            setSelectedRecord(row?._id);
          }}
        />,
      ],
    },
  ];

  useEffect(() => {
    getAllRequestss();
    // eslint-disable-next-line
  }, [paginator]);

  useEffect(() => {
    if (showAlert) {
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
      }, 10000);
      return () => {
        clearTimeout(timeoutId);
      };
    }
    // eslint-disable-next-line
  }, [showAlert]);

  const toggleViewModal = () => setDisplayViewModal(!displayViewModal);
  const toggleDeleteModal = () => setDisplayDeleteModal(!displayDeleteModal);

  const getAllRequestss = async ({ search = "" } = {}) => {
    try {
      const res = await RequestsRouter.getAllPaginated({
        page: paginator.page,
        pageSize: paginator.pageSize,
        type: "Requests",
        search: search,
      });
      if (res?.data) {
        setRequestss(res?.data);
        setTotalCount(res?.pagination?.totalCount);
      }
    } catch (error) {
      console.log("Requestss ", error);
    }
  };

  const updateRequests = async (row) => {
    try {
      const id = row?._id;
      setLoader(true);

      const res = await RequestsRouter.update({
        id: id,
      });
      console.log(res);
      if (res) {
        const msg = res?.data?.message;
        setMessage(msg);
        setShowAlert(true);
        setAlertType("success");
        toggleViewModal();
        getAllRequestss();
        setLoader(false);
      }
    } catch (error) {
      console.log("Requests ", error);
    }
  };

  const removeRequests = async () => {
    try {
      const id = selectedRecord;
      const res = await RequestsRouter.remove(id);
      if (res) {
        getAllRequestss();
        toggleDeleteModal();
      }
    } catch (error) {
      console.log("Requestss ", error);
    }
  };

  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const debounceSearch = debounce(getAllRequestss, 500);

  const handleSearchInput = (e) => {
    const search = e.target.value;
    setSearchTerm(search);
    debounceSearch({ search });
  };

  return (
    <>
      <div className="mainContainer">
        {/* Delete Dialog */}
        <Dialog open={displayDeleteModal} onClose={toggleDeleteModal}>
          <DialogTitle>DELETE Requests</DialogTitle>
          <DialogContent>
            Are you sure you want to disable/delete this Requests?
            <h3 className="infoAlert">
              *All details will be lost and can not be recovered
            </h3>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={toggleDeleteModal}
              variant="contained"
              sx={{ backgroundColor: "#27326A" }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => removeRequests()}
              variant="contained"
              sx={{ backgroundColor: "#FF7C1B" }}
            >
              Delete Requests
            </Button>
          </DialogActions>
        </Dialog>

        <Header></Header>
        <SideNav active="Requests" />
        <div className="contentBox">
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "1%",
              marginTop: "1%",
              gap: "20px",
              alignItems: "center",
            }}
          >
            <TextField
              label="Search"
              margin="dense"
              variant="outlined"
              id="outlined-start-adornment"
              sx={{ m: 1, width: "25ch" }}
              onChange={handleSearchInput}
              value={searchTerm}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon></SearchIcon>
                    </InputAdornment>
                  ),
                },
              }}
            />
          </Box>
          <DataGrid
            sx={{
              borderRadius: 3,
              border: 0,
              width: "100%",
              outline: "none", // Remove blue outline
              ".MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold !important",
                overflow: "visible !important",
                color: "#27326A",
                display: "flex",
                alignItems: "center",
              },
              "& .MuiDataGrid-sortIcon": {
                display: "none !important",
              },
              "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                {
                  outline: "none", // Remove blue outline
                },
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                outline: "none", // Remove blue outline
              },
              "& .MuiDataGrid-cell": {
                outline: "none", // Remove blue outline from cells
              },
              "& .MuiDataGrid-cell--textLeft": {
                textAlign: "left",
              },
              "& .MuiDataGrid-cell--textCenter": {
                textAlign: "center",
              },
              "& .MuiDataGrid-cell--textRight": {
                textAlign: "right",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "transparent !important",
              },
              "& .MuiDataGrid-row.Mui-selected": {
                backgroundColor: "transparent !important",
              },
              "& .MuiDataGrid-row:nth-of-type(even)": {
                backgroundColor: "white",
                boxShadow: "0px 0px 30px #EDEEF4",
                outline: "none",
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                outline: "none",
              },
              "& .name-cell-style": {
                color: "#566477",
                outline: "none",
              },
              "& .default-cell-style": {
                color: "#95A2B4",
                outline: "none",
              },
              "& .MuiDataGrid-row": {
                borderBottom: "none",
                outline: "none",
              },
              "& .MuiDataGrid-columnHeaders": {},
            }}
            disableColumnMenu
            disableSelectionOnClick
            getRowId={(row) => row._id}
            columns={columns}
            rows={Requestss}
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterExcludeHiddenColumns: true,
                },
              },
              pagination: {
                paginationModel: { page: 0, pageSize: paginator.perPage },
              },
            }}
            paginationMode="server"
            rowCount={totalCount}
            onPaginationModelChange={(newPage) => {
              setPaginator({
                page: newPage?.page,
                perPage: newPage?.pageSize,
              });
            }}
            pageSizeOptions={[10]}
          ></DataGrid>
        </div>
      </div>

      {showAlert && (
        <Alert
          severity={alertType}
          sx={{
            position: "absolute",
            top: "80px",
            right: "20px",
            width: "300px",
            zIndex: "999",
          }}
        >
          {message}
        </Alert>
      )}
    </>
  );
};

export default Requests;
